<template>
    <a-card>
        <a-tabs default-active-key="1" @change="callback">
            <a-tab-pane key="1" tab="登录日志">
                <loginLog :visitId="visitId"/>
            </a-tab-pane>
            <a-tab-pane key="2" tab="登出日志">
                <logoutLog :visitId="visitId"/>
            </a-tab-pane>
        </a-tabs>
    </a-card>
</template>
<script>
import loginLog from "./components/loginLog";
import logoutLog from "./components/logoutLog";

export default {
    components:{loginLog,logoutLog},
    data() {
        return {
            visitId:"",
            options:{},
            options1:{},
            timeDate:[],
            loginCount:[],
            logoutCount:[],
        };
    },
    mounted() {

    },
    methods: {
        callback(key) {
            console.log(typeof key);
            this.visitId = key
        }
    },
};
</script>
<style scoped lang="less">
.echartvis{
    width: 100%;
    height: 280px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-echart{
        width: 69%;
        height: 280px;
        //background: #1aad19;
        .title{
            font-size: 20px;
            width: 100%;
            border-bottom: 1px solid #ccc;
        }
    }
    .right-echart{
        width: 30%;
        height: 280px;
        //background: #c59a60;
    }
}
</style>
